import React from "react";
import { Route } from "react-router-dom";
import { InHouseOffersPage } from "@zillout/shared-components";
import PlaceV2 from "../pages/PlaceV2";
import OffersPage from "../pages/OffersPage";
import ReserveExperience from "../pages/ReserveExperience";
import BottomNavLayout from "../layouts/BottomNavLayout";

export const mainRoutes = (
  <>
    <Route
      path="/"
      element={
        <BottomNavLayout>
          <PlaceV2 />
        </BottomNavLayout>
      }
    />
    <Route
      path="/place/:pub_id"
      element={
        <BottomNavLayout>
          <PlaceV2 />
        </BottomNavLayout>
      }
    />
    <Route path="/place/:pub_id/offers" element={<OffersPage />} />
    <Route path="/place/:pub_id/reserve" element={<ReserveExperience />} />
    <Route path="/reserve" element={<ReserveExperience />} />
    <Route path="/in-house-offers" element={<InHouseOffersPage />} />
    <Route
      path="*"
      element={
        <BottomNavLayout>
          <PlaceV2 />
        </BottomNavLayout>
      }
    />
  </>
);
